import { IApiEpBillingProductPlanProduct } from "@smp/api";

import { useHumanizer } from "@/hooks/use_humanizer";

export const NamePlanProduct = ({
  productPlanProduct,
}: {
  productPlanProduct: IApiEpBillingProductPlanProduct;
}) => {
  const { humanizeBillingPlanId } = useHumanizer();
  return <>{humanizeBillingPlanId(productPlanProduct.plan.id)}</>;
};
